import {useOtaMode} from 'hooks/useOtaMode'
import {AccommodationPageNavSections} from 'modules/accommodation/types'

/**
 * Where the hotel-clicker "View deals" CTAs scroll to. OTA mode only returns
 * the brand's own offers, so the "Available deals" section is hidden there and
 * the rooms list takes its place.
 */
export const useViewDealsScrollTarget = () => {
  const {isOTAMode} = useOtaMode()

  return isOTAMode
    ? AccommodationPageNavSections.Rooms
    : AccommodationPageNavSections.Overview
}
